module.exports = __webpack_public_path__ + "static/fonts/icomoon.1f82299a.woff";